module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_payments')) + " " + _vm._s(_vm.isMainAdmin ? '' : ' - ' + _vm.fromDate))]), _vm._v(" "), (_vm.isMainAdmin) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isMainAdmin) ? _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_from'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isMainAdmin) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isMainAdmin) ? _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_to'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu"
  }, [_vm._l((_vm.allCustomCategories), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectCustomCategory(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n              ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "trainings"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.clickSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_do_search')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.showTotalPrice) ? _c('div', {
    staticClass: "foo"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "payment-report-summary-grid"
  }, _vm._l((_vm.paymentSummaryCards), function(item) {
    return _c('div', {
      key: item.type,
      staticClass: "payment-report-summary-card",
      class: 'payment-report-summary-card--' + item.type
    }, [_c('div', {
      staticClass: "payment-report-summary-card__title"
    }, [(item.type === 'cash') ? _c('i', {
      staticClass: "ti-money"
    }) : _vm._e(), _vm._v(" "), (item.type === 'card' || item.type === 'online') ? _c('i', {
      staticClass: "ti-credit-card"
    }) : _vm._e(), _vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "payment-report-summary-card__amount"
    }, [_vm._v("\n          " + _vm._s(_vm.formatMoney(item.amount)) + " " + _vm._s(_vm.locale.t('label_currency')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "payment-report-summary-card__meta"
    }, [_c('span', [_vm._v(_vm._s(_vm.locale.t('label_count_payments')) + ": "), _c('b', [_vm._v(_vm._s(item.count))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t('total_debt')) + ": "), _c('b', {
      class: {
        'icon-danger': item.debt > 0
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(item.debt)) + " " + _vm._s(_vm.locale.t('label_currency')))])])])])
  }), 0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.membershipStats.length > 0) ? _c('div', {
    staticClass: "payment-report-charts"
  }, [_c('div', {
    staticClass: "payment-report-chart-card"
  }, [_c('div', {
    staticClass: "payment-report-chart-card__head"
  }, [_c('h4', [_vm._v(_vm._s(_vm.locale.t('label_count_payments')) + " / " + _vm._s(_vm.locale.t('label_mp_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "payment-report-chart-card__body"
  }, _vm._l((_vm.membershipCountChartData), function(item) {
    return _c('div', {
      key: 'cnt-' + item.membershipName,
      staticClass: "payment-report-chart-row"
    }, [_c('div', {
      staticClass: "payment-report-chart-row__label",
      attrs: {
        "title": item.membershipName
      }
    }, [_vm._v(_vm._s(_vm.shortLabel(item.membershipName, 24)))]), _vm._v(" "), _c('div', {
      staticClass: "payment-report-chart-row__bar-wrap"
    }, [_c('div', {
      staticClass: "payment-report-chart-row__bar payment-report-chart-row__bar--count",
      style: ({
        width: _vm.chartWidth(item.count, _vm.maxMembershipCount)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "payment-report-chart-row__value"
    }, [_vm._v(_vm._s(_vm.formatNumber(item.count)))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "payment-report-chart-card"
  }, [_c('div', {
    staticClass: "payment-report-chart-card__head"
  }, [_c('h4', [_vm._v(_vm._s(_vm.locale.t('label_amount')) + " / " + _vm._s(_vm.locale.t('label_mp_name')) + " (" + _vm._s(_vm.locale.t('label_currency')) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "payment-report-chart-card__body"
  }, _vm._l((_vm.membershipRevenueChartData), function(item) {
    return _c('div', {
      key: 'rev-' + item.membershipName,
      staticClass: "payment-report-chart-row"
    }, [_c('div', {
      staticClass: "payment-report-chart-row__label",
      attrs: {
        "title": item.membershipName
      }
    }, [_vm._v(_vm._s(_vm.shortLabel(item.membershipName, 24)))]), _vm._v(" "), _c('div', {
      staticClass: "payment-report-chart-row__bar-wrap"
    }, [_c('div', {
      staticClass: "payment-report-chart-row__bar payment-report-chart-row__bar--revenue",
      style: ({
        width: _vm.chartWidth(item.revenue, _vm.maxMembershipRevenue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "payment-report-chart-row__value"
    }, [_vm._v(_vm._s(_vm.formatMoney(item.revenue)))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_surname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_username')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_date')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_expire_date')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_paid_date')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_num_trainings')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_name')))]), _vm._v(" "), (_vm.showPaymentColumn) ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_paid')) + " " + _vm._s(_vm.locale.t('label_currency')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_training_type_title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_created_edited')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_equipment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_comment')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_partner')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredPayments), function(payment) {
    return _c('tr', [_c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_name')
      },
      on: {
        "click": function($event) {
          return _vm.paymentUser(payment)
        }
      }
    }, [_vm._v(_vm._s(payment.name) + " "), _c('i', {
      staticClass: "ti-new-window"
    })]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_surname')
      },
      on: {
        "click": function($event) {
          return _vm.paymentUser(payment)
        }
      }
    }, [_vm._v(_vm._s(payment.surname) + " "), _c('i', {
      staticClass: "ti-new-window"
    })]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_username')
      },
      on: {
        "click": function($event) {
          return _vm.paymentUser(payment)
        }
      }
    }, [_vm._v(_vm._s(payment.username) + " "), _c('i', {
      staticClass: "ti-new-window"
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_date')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(payment.paidDate)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_expire_date')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(payment.expireDate)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_paid_date')
      }
    }, [_vm._v(_vm._s(payment.paidTimestamp != null ? _vm.formatDateAndTime(payment.paidTimestamp) : '/'))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_num_trainings')
      }
    }, [_vm._v(_vm._s(payment.trainingNumber))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_mp_name')
      }
    }, [_vm._v(_vm._s(payment.membershipPackageName != null ? payment.membershipPackageName : '/'))]), _vm._v(" "), (_vm.showPaymentColumn) ? _c('td', {
      style: (payment.paidMoney < 0 ? 'color: red;' : 'color: white'),
      attrs: {
        "data-title": _vm.locale.t('label_paid') + ' ' + _vm.locale.t('label_currency')
      }
    }, [_vm._v(_vm._s(payment.paidMoney) + "\n                          "), _c('i', {
      staticClass: "payment-paid-with-icon",
      class: _vm.getPaidWithIconClass(payment),
      attrs: {
        "title": _vm.getPaidWithLabel(payment)
      }
    }), _vm._v(" "), (payment.discount != null && payment.discount > 0) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v("\n                            -" + _vm._s(payment.discount) + "%\n                          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_training_type_title')
      }
    }, [_vm._v(_vm._s(payment.trainingTypes))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_created_edited')
      }
    }, [_vm._v(_vm._s(payment.createdBy != null ? payment.createdBy : '') + _vm._s(payment.editedBy != null ? ' / ' + payment.editedBy : ''))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_equipment')
      }
    }, [_vm._v(_vm._s(_vm.displayAdditionalKit(payment.additionalKit)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_payment_comment')
      }
    }, [_vm._v(_vm._s((payment.comment == null || payment.comment.length === 0 ? '/' : payment.comment)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_partner')
      }
    }, [_vm._v(_vm._s(_vm.displaySaradnik(payment)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deletePayment(payment.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                        ")])])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1455734!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Payment/PaymentReport.vue
// module id = 847
// module chunks = 0